import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SDKApp;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "import/no-webpack-loader-syntax": "warn" */
/* eslint "import/no-unresolved": "warn" */
import { Component } from 'react';
import PropTypes from 'prop-types';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import { jsx } from '@instructure/emotion';
import { ApplyLocale } from '@instructure/ui-i18n';
import { Provider } from '../../react-redux';
import store from '../../../reduxStore';
import { getLocale, withStyleOverrides } from '@instructure/quiz-common';
import { set } from '../../actions/ui';
import { addAlert } from '../../actions/alerts';
import { setAPIEndpoint, setCanvasOrigin, setUserToken } from '../../actions/config';
import { setContextUuid, setOutcomesEndpoint, setOutcomesToken, setExternalAccountUuid } from '../../actions/outcomes';
import { addFeatures, removeFeatures } from '../../actions/features';
import { setGradeByQuestionEnabled } from '../../actions/grading';
import { renderAlerts } from '../../util/renderAlerts';
import generateStyle from './styles';
import CustomPropTypes from '../../../common/util/CustomPropTypes';
import ConfirmationModal from '../ConfirmationModal';
import setupFormatMessage from '@instructure/quiz-i18n/es/util/setupFormatMessage';
import RceConfigProvider from '../RceConfigProvider';
import { ApiFeatureFlagInitializer } from '../ApiFeatureFlagInitializer';
export var SDKApp = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_SDKApp = /*#__PURE__*/function (_Component) {
  function SDKApp(props) {
    var _this;
    _classCallCheck(this, SDKApp);
    _this = _callSuper(this, SDKApp, [props]);

    // TODO: move to something like this down the line
    // so we dont implicitly share state
    // this.store = this.configureStore()
    _defineProperty(_this, "addAlert", function (opts) {
      _this.store.dispatch(addAlert(opts));
    });
    _this.store = store;
    _this.setLocale();
    return _this;
  }
  _inherits(SDKApp, _Component);
  return _createClass(SDKApp, [{
    key: "setLocale",
    value: function setLocale() {
      var locale = getLocale(this.props, this.context);

      // TODO: Move away from using built-in format-message formats so we can kill this setup call
      setupFormatMessage(locale, {
        logMissingTranslations: true,
        translations: this.props.translations
      });
    }
  }, {
    key: "setAppContainer",
    value: function setAppContainer(appContainer) {
      var selectors = Array.isArray(appContainer) ? appContainer : [appContainer];
      return set('appContainer', selectors);
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props$rceConfig;
      this.store.dispatch([setAPIEndpoint(this.props.apiEndpoint), setCanvasOrigin((_this$props$rceConfig = this.props.rceConfig) === null || _this$props$rceConfig === void 0 ? void 0 : _this$props$rceConfig.canvasOrigin), this.setAppContainer(this.props.appContainer), setUserToken(this.props.userToken), setOutcomesEndpoint(this.props.outcomesEndpoint), setOutcomesToken(this.props.outcomesToken), setContextUuid(this.props.contextUuid), setExternalAccountUuid(this.props.externalAccountUuid)]);
      if (this.props.itemBankSharingEnabled) {
        this.store.dispatch(addFeatures('item_bank_sharing'));
      }
      if (this.props.gradeByQuestionEnabled !== null) {
        this.store.dispatch(setGradeByQuestionEnabled(this.props.gradeByQuestionEnabled));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // inserts the a11y friendly alerts
      // react app hooked up to the store
      !this.props.disableAlertLiveRegion && renderAlerts(this.store);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      var _newProps$rceConfig, _this$props$rceConfig2;
      if (newProps.apiEndpoint !== this.props.apiEndpoint) {
        this.store.dispatch(setAPIEndpoint(newProps.apiEndpoint));
      }
      if (((_newProps$rceConfig = newProps.rceConfig) === null || _newProps$rceConfig === void 0 ? void 0 : _newProps$rceConfig.canvasOrigin) !== ((_this$props$rceConfig2 = this.props.rceConfig) === null || _this$props$rceConfig2 === void 0 ? void 0 : _this$props$rceConfig2.canvasOrigin)) {
        this.store.dispatch(setCanvasOrigin(newProps.rceConfig.canvasOrigin));
      }
      if (newProps.appContainer !== this.props.appContainer) {
        this.store.dispatch(this.setAppContainer(newProps.appContainer));
      }
      if (newProps.userToken !== this.props.userToken) {
        this.store.dispatch(setUserToken(newProps.userToken));
      }
      if (newProps.outcomesEndpoint !== this.props.outcomesEndpoint) {
        this.store.dispatch(setOutcomesEndpoint(newProps.outcomesEndpoint));
      }
      if (newProps.outcomesToken !== this.props.outcomesToken) {
        this.store.dispatch(setOutcomesToken(newProps.outcomesToken));
      }
      if (newProps.contextUuid !== this.props.contextUuid) {
        this.store.dispatch(setContextUuid(newProps.contextUuid));
      }
      if (newProps.itemBankSharingEnabled !== this.props.itemBankSharingEnabled) {
        var toggleFeature = newProps.itemBankSharingEnabled ? addFeatures : removeFeatures;
        this.store.dispatch(toggleFeature('item_bank_sharing'));
      }
      if (newProps.gradeByQuestionEnabled !== this.props.gradeByQuestionEnabled && this.props.gradeByQuestionEnabled !== null) {
        this.store.dispatch(setGradeByQuestionEnabled(newProps.gradeByQuestionEnabled));
      }
      if (newProps.externalAccountUuid !== this.props.externalAccountUuid) {
        this.store.dispatch(setExternalAccountUuid(newProps.externalAccountUuid));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var store = this.store,
        props = this.props,
        context = this.context;
      return jsx(Provider, {
        store: store
      }, jsx(ApiFeatureFlagInitializer, null, jsx(RceConfigProvider, this.props.rceConfig, jsx(ApplyLocale, {
        locale: getLocale(props, context),
        timezone: props.timeZone
      }, jsx("div", {
        css: this.props.styles.sdk,
        "data-automation": "sdk-app"
      }, jsx(ConfirmationModal, null), typeof props.children === 'function' ? props.children({
        addAlert: this.addAlert
      }) : props.children)))));
    }
  }]);
}(Component), _defineProperty(_SDKApp, "displayName", 'SDKApp'), _defineProperty(_SDKApp, "componentId", "Quizzes".concat(_SDKApp.displayName)), _defineProperty(_SDKApp, "propTypes", {
  apiEndpoint: PropTypes.string.isRequired,
  appContainer: CustomPropTypes.selectors.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  contextUuid: PropTypes.string,
  externalAccountUuid: PropTypes.string,
  gradeByQuestionEnabled: PropTypes.bool,
  itemBankSharingEnabled: PropTypes.bool,
  // ESLint seems to this the "locale" prop is unused even though it definitely is
  locale: PropTypes.string,
  outcomesEndpoint: PropTypes.string,
  outcomesToken: PropTypes.string,
  rceConfig: PropTypes.shape({
    contextId: PropTypes.string,
    contextType: PropTypes.string,
    canvasOrigin: PropTypes.string,
    canvasUserId: PropTypes.string,
    canvasToolId: PropTypes.string,
    rcsHost: PropTypes.string,
    rcsJwt: PropTypes.string,
    rcsJwtRefreshFn: PropTypes.func,
    displayOldLinks: PropTypes.bool
  }),
  timeZone: PropTypes.string,
  translations: PropTypes.objectOf(PropTypes.shape({
    message: PropTypes.string
  })),
  userToken: PropTypes.string.isRequired,
  disableAlertLiveRegion: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_SDKApp, "contextTypes", {
  locale: PropTypes.string
}), _defineProperty(_SDKApp, "defaultProps", {
  contextUuid: '',
  externalAccountUuid: '',
  gradeByQuestionEnabled: null,
  itemBankSharingEnabled: false,
  locale: null,
  outcomesEndpoint: null,
  outcomesToken: null,
  rceConfig: null,
  translations: null,
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  disableAlertLiveRegion: false
}), _SDKApp)) || _class);
export var DragDroppableSDKApp = DragDropContext(HTML5Backend)(SDKApp);
export default DragDroppableSDKApp;